import { NavigateOptions, useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

import { useMerchant } from '../contexts/MerchantContext';
import { buildUrlWithMerchantId } from '../util/helpers';

/**
 * A wrapper around the useNavigate hook that keeps the merchantId in the search params
 */
export const useMerchantAwareNavigate = () => {
  const navigate = useNavigate();
  const { merchantId } = useMerchant();

  return useCallback(
    (path: string, options?: NavigateOptions) => {
      navigate(buildUrlWithMerchantId(path, merchantId), options);
    },
    [navigate, merchantId],
  );
};
